
import '../sass/style.scss';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, MotionPathPlugin);

import 'bootstrap/dist/js/bootstrap.bundle';

var Flickity = require('flickity');
require('flickity-imagesloaded');

var _ = require('lodash');

/* VUE JS */

window.Vue = require('Vue').default;
window.axios = require('axios');
window.VueGoogleMaps = require('gmap-vue');
window.GmapCustomMarker = require('vue2-gmap-custom-marker').default;


window.Vue.use(GmapCustomMarker);
window.Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDoJjOGhxf55vNdGAkD4moxWKaT9-TMnXw',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});

function installMediaQueryWatcher(mediaQuery, layoutChangedCallback) {
  var mql = window.matchMedia(mediaQuery);
  mql.addListener(function (e) { return layoutChangedCallback(e.matches); });
  layoutChangedCallback(mql.matches);
}


  let _play = document.getElementById("play");
    if (_play) {
      _play.addEventListener("click", function(){
        document.querySelector('.video-recode').scrollIntoView({
          behavior: 'smooth'
      });
      document.querySelector('video').play();
    }, false);
  }

  let _mm = document.querySelector(".hamburger");

    _mm.addEventListener("click", function(){
      _mm.classList.toggle("is-active");
      document.querySelector(".mobile-menu").classList.toggle("opened");
    }, false);

  window.onscroll = function () {

    var st = window.scrollY;
    var heroHeight = document.querySelector('header').offsetHeight;

    if (st > heroHeight){
      document.querySelector('.desktop-navigation').classList.add('down');
      document.querySelector('.mobile-navigation').classList.add('down');

    } else {
      document.querySelector('.desktop-navigation').classList.remove('down');
      document.querySelector('.mobile-navigation').classList.remove('down');

    }
  };

var tl_1 = gsap.timeline();
var tl_2 = gsap.timeline();
var tl_3 = gsap.timeline();

tl_1.from(".v1_animate_hero", {
    y:800,
    ease:"Bounce.easeOut",
    duration: 1.4,
    // scrollTrigger: {
    //   trigger: ".v1_animate_hero",
    //   scrub: true,
    // //    markers:true,
    //   start: "top+10% bottom-50%",
    //   end: "-70% top",
    // },

  });

  tl_1.fromTo(".v1_animate_rect", {x:-1800}, {
    x:-200,
    ease:"none",
  });

  tl_1.fromTo(".v1_animate_rect_mobile", {x:-600}, {
    x:0,
    ease:"none",
  });


let boxes = gsap.utils.toArray(".box");

boxes.forEach(box => {
    tl_1.fromTo(box,
        {
            x: 1500, rotation:360,
        },
        {
            x: 0, rotation:0,
            scrollTrigger: {
                trigger: box,
                end: "-75%",
                scrub: true,
              //  markers:true,
                }

        },
        "<+0.5");
});

let rotate = gsap.utils.toArray(".rotation");
  rotate.forEach((rotate, i) => {
    tl_1.to(rotate, {
    rotation:"360",
    ease:"none",
    delay: 0.5 * rotate[i],
    duration: 1.5,
    repeat: -1,
    transformOrigin:"50% 50%"
  })
});


let bubble = gsap.utils.toArray(".small_bubble");

bubble.forEach((bubble, i) => {
    tl_2.to(bubble, {
    scaleY:0.8,
    scaleX:0.8,
    ease:"circ.in",
    delay: 0.5 * bubble[i],
    duration: 0.75,
    repeat: -1,
    yoyo: true,
  })
});

tl_1.fromTo(".img_v1_left",
    {
      x:-900,
    },
    {
      x:-300,
      scrollTrigger: {
          trigger: ".img_v1_left",
        //  end: "bottom bottom",
          scrub: true,
      //   markers:true,
          }
    },
   );


tl_1.fromTo(".img_v1_right",
    {
        x:500,
    },
    {
        x:-100,
        scrollTrigger: {
            trigger: ".img_v1_right",
          //  end: "bottom bottom",
            scrub: true,
         //   markers:true,
            }
    },
);


let sections = gsap.utils.toArray(".how_works");

gsap.to(sections, {
  xPercent: -80 * (sections.length - 1),
  ease: "none",
  scrollTrigger: {
    trigger: ".how_works_hscroll",
    // scroller : ".how_works_hscroll",
    pin: true,
    scrub: 1,
    //markers: true,
    snap: 1 / (sections.length - 1),
     start: "40% center",
    // base vertical scrolling on how wide the container is so it feels more natural.
    end: "60% center",
  }
});


tl_3.fromTo(".img_v3_right",
    {
        x:800,
    },
    {
        x:100,

    },
);


let v3_right = gsap.utils.toArray(".v3_animate_right");
let v3_left = gsap.utils.toArray(".v3_animate_left");

installMediaQueryWatcher("(min-width: 768px)", function(matches) {

  if (matches) {

      v3_right.forEach(v3_right => {
            tl_3.fromTo(v3_right,
              {
                x:700,
              },
              {
                  x:180,
                  scrollTrigger: {
                    trigger: v3_right,
                    end: "center center",
                    scrub: true,
                //   markers:true,
                    }
              },
              "<+2"
            );
        });


      v3_left.forEach(v3_left => {
        tl_3.fromTo(v3_left,
          {
            x:-700,
          },
          {
              x:-180,
              scrollTrigger: {
                trigger: v3_left,
                end: "center center",
                scrub: true,
            //   markers:true,
                }
          },
          "<+2"
        );
      });
  }
});

tl_3.from(".v3_animate_0",{
    y:3300,
    ease:"none",
    //duration: 1.5,
    scrollTrigger: {
      trigger: ".v3_animate",
      start: "top 80%",
      end: "center bottom",
      scrub: true,
    //  markers:true,
    },

});
